// extracted by mini-css-extract-plugin
module.exports = {"title":"CreateAttributeStepper_title_1e4La","pureLabelButton":"CreateAttributeStepper_pureLabelButton_DV2J8","backButton":"CreateAttributeStepper_backButton_YuKRc"};